import axios from 'axios';
import { ESTADO_APROBACION_PARCIAL, ESTADO_APROBADO, ESTADO_ENVIADO_TALENTO_HUMANO, ESTADO_NO_HA_PLANIFICADO, ESTADO_PENDIENTE } from 'components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones';
import Cargando from 'components/Varios/Cargando';
import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { authenticationService } from 'services/authentication.service';
import { PRIMER_APROBADOR, SEGUNDO_APROBADOR } from './ModalDirectivo';
import { ReactComponent as AnuncioSVG } from "assets/icons/Permisos/Anuncio.svg"

//URL
import configData from "../../../config.json";
import { handle_error } from './helper_function';
import { Rows_Resumen_Directivo } from './PlanificacionVacaciones';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';
type Props_ModalEnviarTalentoHumano = {
    show: boolean
    toogle: () => void
    onClose: () => void
    tipo_aprobador: string,
    tipo_personal: string,
    periodoExtraordinario: boolean,
    informacionPersonal: Array<Rows_Resumen_Directivo>
}
export type RequestEnviarTalentoHumano = {
    estado: string
}





const ModalEnviarTalentoHumano: React.FC<Props_ModalEnviarTalentoHumano> = (props: Props_ModalEnviarTalentoHumano) => {


    const [loadingContenido, setloadingContenido] = useState<boolean>(false)
    const [confirmado, setconfirmado] = useState<boolean>(false)
    const [tipo_aprobador, settipo_aprobador] = useState<string>("")
    const [accion_realizar, setaccion_realizar] = useState<string>("")
    const [aceptar, setaceptar] = useState<number>(-1)

    const [erroresEnviarDirectivo, seterroresEnviarDirectivo] = useState<Array<string>>([])


    const cerrar_modal = () => {
        setconfirmado(false)
        setaceptar(-1)
        setloadingContenido(false)
        props.toogle();
    }

    useEffect(() => {
        if (props.tipo_aprobador !== "") {
            settipo_aprobador(tipo_aprobador);
            var accion: string = "";
            if (props.tipo_aprobador === PRIMER_APROBADOR) {
                accion = "enviar las planificaciones al directivo"
            }
            else if (props.tipo_aprobador === SEGUNDO_APROBADOR) {
                accion = "aprobar todas las planificaciones con estado parcialmente aprobadas"
            }
            setaccion_realizar(accion);

        }
    }, [props.tipo_aprobador])

    useEffect(() => {

        const handleEnviarTalentoHumano = async (tipo_aprobador: string) => {
            const ERROR_ENVIAR_DIRECTIVO = "NO HAY PLANIFICACIONES QUE SE PUEDAN APROBAR"
            setloadingContenido(true);
            var currentUser = authenticationService.currentUserValue;

            var RequestEnviarPlanificacionesDTO: RequestEnviarTalentoHumano = { estado: ESTADO_ENVIADO_TALENTO_HUMANO };
            // var estado_enviar = ESTADO_ENVIADO_TALENTO_HUMANO;

            try {
                const respuesta_request = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/AprobarEnviarTodas/${props.tipo_personal}`, RequestEnviarPlanificacionesDTO,
                    {
                        headers: {

                            'Content-Type': 'application/json',
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }
                    });

                var personas_modificadas: Array<number> = respuesta_request.data;
                window.location.reload();

            } catch (error) {
                var error_any: any = error
                var status_error = handle_error(error_any);
                var errores_response: Array<string> = ["Ha ocurrido un inconveniente"];
                switch (status_error) {
                    case 415:
                        errores_response.push("La información que ha enviado no es válida")
                        break;

                    case 401:
                        errores_response.push("No está autorizado a realizar está acción")
                        break;

                    case 400:
                        errores_response.push("La información que ha enviado no es válida")
                        break;
                    case 409:
                        if (error_any.response && error_any.response.data === ERROR_ENVIAR_DIRECTIVO && props.tipo_aprobador === PRIMER_APROBADOR)
                            errores_response.push("Sus planificaciones ya se enviaron al segundo Aprobador")
                        else if (error_any.response && error_any.response.data === ERROR_ENVIAR_DIRECTIVO && props.tipo_aprobador === SEGUNDO_APROBADOR)
                            errores_response.push("Debe esperar a que el primer directivo termine de aprobar las planificaciones o Es probable que las planificaciones ya se aprobaron en su totalidad")
                        break;
                    default:
                        errores_response.push("No es posible contactar con el servidor")
                        break;
                }
                seterroresEnviarDirectivo(errores_response);


            }
            setconfirmado(true);
            setloadingContenido(false)
        }


        if (aceptar > -1 && props.tipo_aprobador !== "") {
            handleEnviarTalentoHumano(props.tipo_aprobador)
        }


    }, [aceptar])

    const handlevalorenviar = (valor: number) => {
        return valor + 1;
    }


    const nroPersonalNoEnviadoATH = props.informacionPersonal.filter((v) => v.estadoaprobacion !== ESTADO_ENVIADO_TALENTO_HUMANO).length.toString()
    const nroPersonalNoPlanificado = props.informacionPersonal.filter((v) => v.estadoaprobacion === ESTADO_NO_HA_PLANIFICADO).length
    const nroPersonalPendiente = props.informacionPersonal.filter((v) => v.estadoaprobacion === ESTADO_PENDIENTE).length





    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"md"}
            fullscreen={"md"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={<IconCloseModal handleClickIcon={() => cerrar_modal()} />} />
            <ModalBody>
                {
                    props.periodoExtraordinario &&

                    <div className="containerAnuncioMETH" >
                        <AnuncioSVG className='iconoAnuncioModalETH'   />
                        <small className={"small-error text-justify"}>
                            Aviso importante: Durante el período extraordinario, se le permite enviar la información a Talento Humano, incluso si no todo el personal ha completado su planificación.</small>
                    </div>


                }
                {
                    !props.periodoExtraordinario &&
                    <div className="titulo_modal_enviar_planificaciones">Confirmación acción  </div>
                }

                {
                    loadingContenido && <Cargando />
                }
                {
                    !loadingContenido && !confirmado &&
                    <React.Fragment>
                        <Row>
                            <Col xl={12} className="text-center">
                                <>
                                    <div>
                                        ¿Está seguro que desea enviar las planificaciones con estado <strong>APROBADAS</strong> a Talento Humano?
                                    </div>
                                    {
                                        nroPersonalNoPlanificado === 1 &&
                                        <div> {"Actualmente hay "} <strong>{nroPersonalNoPlanificado.toString()}</strong> {" persona que no ha planificado"}  </div>
                                    }
                                    {
                                        nroPersonalNoPlanificado > 1 &&
                                        <div> {"Actualmente hay "} <strong>{nroPersonalNoPlanificado.toString()}</strong> {" personas que no han planificado"}  </div>
                                    }
                                    {
                                        nroPersonalPendiente === 1 &&
                                        <div> {"Actualmente hay "} <strong>{nroPersonalPendiente.toString()}</strong> {" persona  con planificaciones pendientes de aprobar"}  </div>

                                    }
                                    {
                                        nroPersonalPendiente > 1 &&
                                        <div> {"Actualmente hay "} <strong>{nroPersonalPendiente.toString()}</strong> {" personas con planificaciones pendientes de aprobar"}  </div>

                                    }



                                </>


                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-1">
                            <Col xl={6} md={6} sm={12} className="text-md-right text-center text-center ">
                                <div className="container_botones">
                                    <button className="btnAprobarPlanificacion" onClick={() => setaceptar(handlevalorenviar(1))}> Aceptar</button>
                                </div>

                            </Col>
                            <Col xl={6} md={6} sm={12} className="text-md-left text-lg-left text-center mt-1 mt-sm-1 mt-md-0 ">
                                <div className="container_botones">
                                    <button className="btnRechazarPlanificacion" onClick={() => cerrar_modal()}> Cancelar </button>
                                </div>

                            </Col>
                        </Row>

                    </React.Fragment>
                }
                {
                    !loadingContenido && confirmado && erroresEnviarDirectivo.length != 0 &&

                    <React.Fragment>
                        <Row>

                            <Col xl={10} lg={8} className="col_mensajesEnviarDirectivo ">
                                {
                                    erroresEnviarDirectivo.map((texto_errores, index_error_directivo) => {
                                        return (
                                            <React.Fragment key={"error_enviar_Directivo " + index_error_directivo}>
                                                <small className="erroresEnviarDirectivo mt-1 text-center">
                                                    {`${index_error_directivo == 0 ? "" : index_error_directivo + ")"} ${texto_errores}`}
                                                </small>
                                                <br />

                                            </React.Fragment>
                                        )

                                    })
                                }
                            </Col>
                        </Row>
                    </React.Fragment>
                }
                {
                    !loadingContenido && confirmado && erroresEnviarDirectivo.length === 0 &&
                    <React.Fragment>
                        <div>La operación se ha realizado con éxito, espere un momento...</div>
                    </React.Fragment>
                }






            </ModalBody>
        </Modal>
    )
}
export default ModalEnviarTalentoHumano;
